var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_30318)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 81,
    height: 81,
    rx: 40.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1126 57.1813C47.6813 57.1813 47.2501 57.0876 46.8563 56.8813C46.7626 56.8251 46.6688 56.7688 46.5938 56.6938L43.4626 54.0313L40.3876 56.6938C40.2938 56.7688 40.2001 56.8251 40.1063 56.8813C39.3751 57.2376 38.5501 57.2751 37.8188 56.9563C37.0688 56.6376 36.5063 56.0188 36.2438 55.2501L35.6438 53.4501C35.3251 52.5126 35.6063 51.3313 36.3001 50.6188L39.4313 47.5438L39.4126 44.8251L33.7688 47.2438C32.8313 47.6376 31.8563 47.6001 31.1063 47.0938C30.3751 46.6251 29.9438 45.7438 29.9438 44.7313V42.9876C29.9438 41.5251 30.9563 39.9688 32.3063 39.3876L39.4126 36.3313V32.7501C39.4126 30.9126 40.6313 28.9251 42.2626 28.1376C43.0688 27.7438 43.9876 27.7438 44.7938 28.1376C46.4251 28.9813 47.6438 30.9688 47.6438 32.7501V36.3313L54.7501 39.3876C56.1001 39.9501 57.1126 41.5063 57.1126 42.9876V44.7313C57.1126 45.7438 56.6813 46.6251 55.9126 47.1126C55.1438 47.6001 54.1876 47.6563 53.2501 47.2626L47.6251 44.8438V47.6001L50.6813 50.6563C51.3751 51.3501 51.6563 52.5501 51.3376 53.4876L50.7376 55.2688C50.4751 56.0376 49.9126 56.6563 49.1626 56.9563C48.8251 57.1063 48.4688 57.1813 48.1126 57.1813ZM43.5001 51.2563C44.1376 51.2563 44.7563 51.4626 45.2626 51.8563L48.1688 54.3313L48.6751 52.5876L45.6188 49.5501C45.1313 49.0814 44.8126 48.2938 44.8126 47.6001V44.1313C44.8126 43.2876 45.1688 42.5563 45.8063 42.1251C46.4438 41.6938 47.2688 41.6376 48.0563 41.9751L54.2813 44.6376L54.3001 42.9876C54.3001 42.6313 53.9626 42.1063 53.6438 41.9751L46.2376 38.7876C45.4313 38.4501 44.8313 37.5501 44.8313 36.6313V32.7501C44.8313 32.0188 44.1938 30.9876 43.5376 30.6501C42.8626 30.9876 42.2251 32.0001 42.2251 32.7501V36.6313C42.2251 37.5126 41.6438 38.4313 40.8188 38.7876L33.4313 41.9751C33.1126 42.1063 32.7563 42.6501 32.7563 42.9876V44.6376L38.9626 41.9938C39.7313 41.6563 40.5376 41.6938 41.1938 42.1251C41.8501 42.5563 42.2251 43.2876 42.2251 44.1501V47.6188C42.2251 48.2938 41.9063 49.0814 41.4188 49.5688L38.2688 52.6626L38.8688 54.3126L41.7001 51.9126C42.2251 51.4813 42.8626 51.2563 43.5001 51.2563ZM47.3438 36.2001L47.3626 36.2188C47.3626 36.2001 47.3438 36.2001 47.3438 36.2001Z",
    fill: "url(#paint0_linear_19_30318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.125 62.6562H37.875C27.6938 62.6562 23.3438 58.3063 23.3438 48.125V36.875C23.3438 26.6938 27.6938 22.3438 37.875 22.3438H49.125C59.3063 22.3438 63.6562 26.6938 63.6562 36.875V48.125C63.6562 58.3063 59.3063 62.6562 49.125 62.6562ZM37.875 25.1562C29.2312 25.1562 26.1562 28.2312 26.1562 36.875V48.125C26.1562 56.7687 29.2312 59.8438 37.875 59.8438H49.125C57.7687 59.8438 60.8438 56.7687 60.8438 48.125V36.875C60.8438 28.2312 57.7687 25.1562 49.125 25.1562H37.875Z",
    fill: "url(#paint1_linear_19_30318)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_30318",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_30318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_30318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_30318",
    x1: 43.5282,
    y1: 27.8423,
    x2: 43.5282,
    y2: 57.1813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_30318",
    x1: 43.5,
    y1: 22.3437,
    x2: 43.5,
    y2: 62.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExporticon);
export default __webpack_public_path__ + "static/media/exporticon.b7dcd9e4b94feefd3753e00b98f3545b.svg";
export { ForwardRef as ReactComponent };